import { useFormContext } from "react-hook-form";

import { PostgreSQLSecretField } from "src/connections/config/database/postgresql/PostgreSQLSecretField";
import { ConfigFieldsetCard as FieldsetCard } from "src/connections/config/FieldsetCard";
import { isFieldErrored } from "src/connections/config/isFieldErrored";
import {
  Environment,
  PostgreSQLConnectionConfigInputs,
} from "src/connections/types";

type Props = {
  environment: Environment;
};

export const PostgreSQLUsernamePasswordAuthFieldset: React.FC<Props> = ({
  environment,
}) => {
  const {
    formState: { errors },
  } = useFormContext<PostgreSQLConnectionConfigInputs>();
  const envErrors =
    errors?.[`${environment}Config`]?.["usernamePasswordConfig"];

  return (
    <FieldsetCard className="last:mb-0">
      <PostgreSQLSecretField
        environment={environment}
        helpText="The username used to connect to the database"
        isErrored={isFieldErrored(envErrors, "username")}
        secretConfigField="usernamePasswordConfig.username"
        secretName="Username"
        isRequired
      />
      <PostgreSQLSecretField
        environment={environment}
        helpText="The password used to connect to the database"
        isErrored={isFieldErrored(envErrors, "password")}
        secretConfigField="usernamePasswordConfig.password"
        secretName="Password"
        isRequired
      />
    </FieldsetCard>
  );
};
